import { getRequest } from '../services/requestHandler';
import { BsgShoeSize } from '../models';

export const getBsgShoeSizes = async () => {
  const url = 'bsgshoe/getBsgShoeSize?activeOnly=true';
  const response = await getRequest<BsgShoeSize>('GetBsgShoeSizes', url);
  return response;
};
